import { roomPath, type AppRoute } from "./routes";

export function parentPath(route: AppRoute): string | undefined {
  if (route.screen === "information") return "/";
  if (route.screen === "delete-account") return "/account/reports";
  if (route.screen === "account") return route.orderId ? "/account/reports" : "/reports";
  if (route.screen === "issue") return roomPath(route.roomId);
  if (route.screen === "room" || route.screen === "review" || route.screen === "export") return "/rooms";
  if (route.screen === "rooms" || route.screen === "reports") return "/";
  return undefined;
}

export function swipeDestination(direction: "left" | "right", route: AppRoute): string | undefined {
  // Detail screens use a rightward swipe on content to return to their parent.
  // System edge gestures continue through Capacitor's Android Back dispatcher.
  if (direction === "right" && ["room", "issue", "reports", "account", "delete-account"].includes(route.screen)) {
    return parentPath(route);
  }
  const tabs = ["rooms", "review", "export"];
  const index = tabs.indexOf(route.screen);
  if (index < 0) return undefined;
  const next = tabs[index + (direction === "left" ? 1 : -1)];
  return next ? `/${next}` : undefined;
}
